import React from 'react';
import PropTypes from 'prop-types';
import { InputPlain } from 'modules/styled/web';
import { LinkFont, SecondaryText, Row, View } from 'modules/styled';

const Checkbox = (props) => {
  const { label, input, type, meta, name, placeholder, autocomplete } = props;
  const { dirty, touched, error, warning } = meta;
  return (
    <View sx={{ mt: 3 }}>
      <Row sx={{ alignItems: 'baseline' }}>
        <InputPlain
          {...input}
          placeholder={placeholder || label}
          autoComplete={autocomplete}
          name={name}
          type={type}
          sx={{ mr: 1 }}
        />{' '}
        {label ? (
          <label html-for={name}>
            <LinkFont sx={{ color: 'black' }}>{label}</LinkFont>
          </label>
        ) : null}
        {(dirty || touched) &&
          ((error && (
            <SecondaryText sx={{ mt: 1, color: 'red' }}>{error}</SecondaryText>
          )) ||
            (warning && <SecondaryText sx={{ color: 'red' }}>{warning}</SecondaryText>))}
      </Row>
    </View>
  );
};

Checkbox.propTypes = {
  error: PropTypes.string,
  type: PropTypes.string,
  name: PropTypes.string,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  meta: PropTypes.object,
  input: PropTypes.object,
  autocomplete: PropTypes.string,
};

Checkbox.defaultProps = {
  autocomplete: null,
};

export default Checkbox;
